import React from 'react';
import {Slider} from 'MWC';
import '../../less/payment-notice.less';
import '../../less/payment-notice-mobile.less';
import pay1 from '../../../../img/pay.svg';
import pay2 from '../../../../img/pay_2.svg';

export default function template() {
    return (
        <div className="module-payment-notice-container">
            <div className="module-content-wrapper">
                <p className="main-title">{this.l10n('APPLE_PAY_PAYMENT_CARD')}</p>

                <div className="main-payment-notice-content">
                    <div className="left-side">
                        <p>{this.l10n('APPLE_PAY_PAYMENT_CARD_TEXT_1')}</p>
                        <p>{this.l10n('APPLE_PAY_PAYMENT_CARD_TEXT_2')}</p>
                    </div>
                    <div className="right-side">
                        <div className="slider-container">
                            <Slider showNavigation>
                                <div className="slide">
                                    <div className="slide-content">
                                        <video width="100%" height="210" controls>
                                            <source
                                                src="https://www.apple.com/105/media/ru/apple-pay/2017/1b3e5430_fafc_4e9d_8114_4ba5eacf00f4/overview/films/pay-in-store/apple-pay-pay-in-store-tpl-ru-20170912_720x1280h.mp4"
                                                type="video/mp4"
                                            />
                                        </video>
                                    </div>
                                </div>
                                <div className="slide">
                                    <div className="slide-content">
                                        <video width="100%" height="210" controls>
                                            <source
                                                src="https://www.apple.com/105/media/ru/apple-pay/2017/1b3e5430_fafc_4e9d_8114_4ba5eacf00f4/overview/films/add-a-card/apple-pay-add-a-card-tpl-ru-20170912_720x1280h.mp4"
                                                type="video/mp4"
                                            />
                                        </video>
                                    </div>
                                </div>
                            </Slider>
                        </div>
                        <p className="info">{this.l10n('APPLE_PAY_PAYMENT_NOTICE')}</p>
                        <div className="sign-wrapper">
                            <div>
                                <img src={pay1} alt="" />
                                <img src={pay2} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
